"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _DropdownList = _interopRequireDefault(require("react-widgets/lib/DropdownList"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down5"));
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _plusCircle = _interopRequireDefault(require("cccisd-icons/plus-circle2"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _Session = _interopRequireDefault(require("./Session"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var AppDefs = window.cccisd.appDefs;
var AssignmentPlan = function AssignmentPlan(_ref) {
  var deployments = _ref.deployments,
    displaySettings = _ref.displaySettings,
    groupAndDescendants = _ref.groupAndDescendants,
    isHideDcwDropdown = _ref.isHideDcwDropdown,
    isHideRoleDropdown = _ref.isHideRoleDropdown,
    index = _ref.index,
    plan = _ref.plan,
    planError = _ref.planError,
    planErrors = _ref.planErrors,
    plans = _ref.plans,
    updatePlanErrors = _ref.updatePlanErrors,
    updatePlans = _ref.updatePlans;
  if (plan.toDelete) {
    return null;
  }
  var deploymentHandles = displaySettings.deploymentHandles,
    disableAddAssignmentPlan = displaySettings.disableAddAssignmentPlan,
    hideDatePickers = displaySettings.hideDatePickers;
  var _useState = (0, _react.useState)('isExpanded' in plan ? plan.isExpanded : true),
    _useState2 = _slicedToArray(_useState, 2),
    isPlanExpanded = _useState2[0],
    setIsPlanExpanded = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    _useState4 = _slicedToArray(_useState3, 2),
    firstLoad = _useState4[0],
    setFirstLoad = _useState4[1];
  var _useState5 = (0, _react.useState)(plan.label || ''),
    _useState6 = _slicedToArray(_useState5, 2),
    label = _useState6[0],
    setLabel = _useState6[1];
  var _useState7 = (0, _react.useState)(plan.role || ''),
    _useState8 = _slicedToArray(_useState7, 2),
    role = _useState8[0],
    setRole = _useState8[1];
  var _useState9 = (0, _react.useState)(plan.sessions || []),
    _useState0 = _slicedToArray(_useState9, 2),
    sessions = _useState0[0],
    setSessions = _useState0[1];
  var _useState1 = (0, _react.useState)([]),
    _useState10 = _slicedToArray(_useState1, 2),
    sessionErrors = _useState10[0],
    setSessionErrors = _useState10[1];

  /* /////////////////////////////////////////////////////////////////////////
  // LIFECYCLE-RELATED //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  (0, _react.useEffect)(function () {
    if (sessions.length === 0) {
      addSession();
    }
  }, [sessions]);
  (0, _react.useEffect)(function () {
    if (!firstLoad) {
      setLabel(plan.label || '');
      setRole(plan.role || '');
      setSessions(plan.sessions || []);
    } else {
      setFirstLoad(false);
    }
  }, [plan]);
  (0, _react.useEffect)(function () {
    if (planError) {
      setIsPlanExpanded(true);
      var newSessionErrors = [];
      sessions.forEach(function (_, i) {
        newSessionErrors.push((0, _get2["default"])(planError.sessions, "session".concat(i)));
      });
      setSessionErrors(newSessionErrors);
    }
  }, [planError]);

  /* /////////////////////////////////////////////////////////////////////////
  // GENERAL FUNCTIONS //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  function addSession() {
    var deploymentId;
    if (isHideDcwDropdown) {
      var _deployments$find;
      deploymentId = (_deployments$find = deployments.find(function (d) {
        return d.deploymentHandle === deploymentHandles[0];
      })) === null || _deployments$find === void 0 ? void 0 : _deployments$find.deploymentId;
    }
    var newSession = {
      label: '',
      deploymentId: deploymentId,
      isExpanded: true
    };
    updateSessions([].concat(_toConsumableArray(sessions), [newSession]));
  }
  function changeField(event, customSet) {
    updatePlans(plans.map(function (p, i) {
      if (i === index) {
        p[event.target.name] = event.target.value;
        customSet(event.target.value);
      }
      return p;
    }));
  }
  function deletePlan() {
    if (!plan.planId) {
      updatePlanErrors(planErrors.filter(function (_, i) {
        return i !== index;
      }));
      updatePlans(plans.filter(function (_, i) {
        return i !== index;
      }));
      return;
    }

    /* SELweb districts use group.settings.defaultAssignmentPlans,
     *  so we need to check there too. same pattern could be used in any app
     */
    var selectedAsDefaultGroupCount = 0;
    groupAndDescendants.forEach(function (g) {
      try {
        var defaultAssignmentPlans = (0, _get2["default"])(g, 'group.settings.defaultAssignmentPlans', null);
        if (!defaultAssignmentPlans) {
          return;
        }
        if (Object.values(defaultAssignmentPlans).find(function (val) {
          return parseInt(val, 10) === parseInt(plan.planId, 10);
        })) {
          selectedAsDefaultGroupCount++;
        }
      } catch (e) {
        // meh *shrug*, settings.defaultAssignmentPlans blob probably formatted differently
      }
    });
    var description = 'Are you sure you want to mark this Assignment Plan for deletion?';
    if (plan.selectedByGroupCount && selectedAsDefaultGroupCount) {
      description = "This Assigment Plan is being used by ".concat(plan.selectedByGroupCount, " group").concat(plan.selectedByGroupCount === 1 ? '' : 's', " directly and ").concat(selectedAsDefaultGroupCount, " group").concat(selectedAsDefaultGroupCount === 1 ? '' : 's', " in default settings. Are you sure you want to mark it for deletion?");
    } else if (plan.selectedByGroupCount) {
      description = "This Assignment Plan is being used by at least ".concat(plan.selectedByGroupCount, " group").concat(plan.selectedByGroupCount === 1 ? '' : 's', ". Are you sure you want to mark it for deletion?");
    } else if (selectedAsDefaultGroupCount) {
      description = "This Assignment Plan is being used in default settings for ".concat(selectedAsDefaultGroupCount, " group").concat(selectedAsDefaultGroupCount === 1 ? '' : 's', ". Are you sure you want to mark it for deletion?");
    }
    description += ' (Delete performed on form submission.)';
    (0, _cccisdConfirm["default"])({
      message: 'Delete Assignment Plan',
      description: description
    }).then(function () {
      updatePlanErrors(planErrors.filter(function (_, i) {
        return i !== index;
      }));
      updatePlans(plans.map(function (p, i) {
        if (i === index) {
          p.toDelete = true;
        }
        return p;
      }));
    });
  }
  function updateSessions(updatedSessions) {
    var asEvent = {
      target: {
        name: 'sessions',
        value: updatedSessions
      }
    };
    changeField(asEvent, setSessions);
  }

  /* /////////////////////////////////////////////////////////////////////////
  // RENDER-RELATED /////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  var collapseArrow = /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      return setIsPlanExpanded(function (prev) {
        return !prev;
      });
    },
    className: [_style["default"].collapseArrow, isPlanExpanded ? _style["default"].expanded : _style["default"].collapsed].join(' ')
  }, /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null));
  var planActionButton = /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-xs btn-danger float-end",
    onClick: deletePlan
  }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
    title: "Delete Assignment Plan"
  }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null)));
  function renderLabelField() {
    var hasError = (0, _get2["default"])(planError, 'label');
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].formField
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "form-label ".concat(_style["default"].indentedLabel, " ").concat(isPlanExpanded ? '' : _style["default"].collapsed)
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].required
    }, "Plan Name:"), "\xA0\xA0", !isPlanExpanded && /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].collapsedField
    }, label)), isPlanExpanded && /*#__PURE__*/_react["default"].createElement("input", {
      className: (0, _classnames["default"])('form-control', hasError && 'is-invalid'),
      name: "label",
      onChange: function onChange(e) {
        return changeField(e, setLabel);
      },
      type: "text",
      value: label
    }), hasError && /*#__PURE__*/_react["default"].createElement("div", {
      className: "invalid-feedback"
    }, "Plan Name is required"));
  }
  function renderRoleDropdown() {
    var roleHandles = displaySettings.roleHandles;

    // role automatically set in addPlan method of parent component, so no UI needed
    if (isHideRoleDropdown) {
      return null;
    }
    var hasError = (0, _get2["default"])(planError, 'role');
    var isRoleReadOnly = sessions.some(function (s) {
      return s.deploymentId;
    });
    var dcwRoles = deployments.map(function (d) {
      return d.roleHandle;
    });
    if (Array.isArray(roleHandles)) {
      dcwRoles = dcwRoles.filter(function (handle) {
        return roleHandles.includes(handle);
      });
    }
    var roleDropdown = /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].formField
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "form-label ".concat(_style["default"].required)
    }, "Role:"), /*#__PURE__*/_react["default"].createElement(_DropdownList["default"], {
      data: AppDefs.pawn.roles.filter(function (r) {
        return dcwRoles.includes(r.handle);
      }),
      readOnly: isRoleReadOnly,
      onChange: function onChange(e) {
        return changeField({
          target: {
            name: 'role',
            value: e.handle
          }
        }, setRole);
      },
      placeholder: "--- Choose a Role ---",
      textField: "label",
      value: role,
      valueComponent: function valueComponent(_ref2) {
        var item = _ref2.item;
        return item.label || role;
      },
      valueField: "handle",
      className: (0, _classnames["default"])(hasError && 'is-invalid')
    }), hasError && /*#__PURE__*/_react["default"].createElement("div", {
      className: "invalid-feedback"
    }, "Role is required"));
    return isRoleReadOnly ? /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: 'You must clear all Data Collection Wave selections' + " in this Plan's sessions before changing Role"
    }, roleDropdown) : roleDropdown;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].planContainer
  }, collapseArrow, isPlanExpanded && disableAddAssignmentPlan !== true && planActionButton, renderLabelField(), isPlanExpanded && renderRoleDropdown(), isPlanExpanded && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].sessionsContainer
  }, sessions.map(function (s, i) {
    return /*#__PURE__*/_react["default"].createElement(_Session["default"], {
      deployments: deployments,
      displaySettings: displaySettings,
      isHideDcwDropdown: isHideDcwDropdown,
      index: i,
      key: i,
      role: role,
      session: s,
      sessionError: sessionErrors[i],
      sessionErrors: sessionErrors,
      sessions: sessions,
      updateSessionErrors: setSessionErrors,
      updateSessions: updateSessions
    });
  }), hideDatePickers !== true && /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-secondary",
    onClick: addSession
  }, /*#__PURE__*/_react["default"].createElement(_plusCircle["default"], null), " Add Session")));
};
AssignmentPlan.propTypes = {
  deployments: _propTypes["default"].array,
  displaySettings: _propTypes["default"].object,
  groupAndDescendants: _propTypes["default"].array,
  isHideDcwDropdown: _propTypes["default"].bool,
  isHideRoleDropdown: _propTypes["default"].bool,
  index: _propTypes["default"].number,
  plan: _propTypes["default"].object,
  planError: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]),
  planErrors: _propTypes["default"].array,
  plans: _propTypes["default"].array,
  updatePlanErrors: _propTypes["default"].func,
  updatePlans: _propTypes["default"].func
};
var _default = exports["default"] = AssignmentPlan;